export const ProjectData=[
    {
        id:1,
        title:"Ecommerce page",
        about: "This is a ecommerce page where i used API to fetch data and show product data as per selected category,Redux to manage state of those products.",
        tags:["ReactJS", "Redux", "API", "Html/Css"],
        demo:"https://ecommerce-page-react-js.vercel.app/product/offer",
        github:"https://github.com/Keshab66/Ecommerce-Page-React.js",
        image:require("../../assets/projects/ecommerce.png"),
    },
    {
        id:1,
        title:"Reponsive Portfolio",
        about: "This is a ramdom project I am using to React.JS,Javascript, HTML/CSS.This is portfolio website and I hope you are enjoying this portfolio.Make sure to contact if you have any issues",
        tags:["ReactJS", "Javascript", "Firebase", "Portfolio"],
        demo:"https://portfolio-me-phi.vercel.app/",
        github:"https://github.com/Keshab66/Portfolio.me",
        image:require("../../assets/projects/portfolio.png"),
    },
    {
        id:1,
        title:"Resturant food order page",
        about: "This is a ramdom project I am using  React.JS,Javascript, HTML/CSS.This is Resturant website and I hope you are enjoying this food order page.Make sure you  comment if you have any doubt",
        tags:["ReactJS", "Javascript", "Firebase"],
        demo:"",
        github:"",
        image:require("../../assets/projects/restro.png"),
    }
];